import { UserContext } from "components/user";
import CartaObjectStorage from "data/CartaObjectStorage"
import { useContext, useEffect, useState } from "react";
import { config as loadConfig } from "library/api"


export default function useCartaObjectStorage() {

    const {carta} = useContext(UserContext);

    const [cartaObjectStorage, setCartaObjectStorage] = useState<CartaObjectStorage>();

    const [config, setConfig] = useState<Awaited<typeof loadConfig> | undefined>(undefined)

    useEffect(()=>{
        (async ()=>{
            setConfig(await loadConfig);
        })();

    }, [])

    useEffect(()=>{
        (async ()=>{
            if(!carta || !config){
                return;
            }
            setCartaObjectStorage(new CartaObjectStorage(carta, config));
            
        })();
    }, [carta, config])

    return cartaObjectStorage;
}